import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// Image imports with descriptive names
import inauguration1 from "../../assets/hero1.jpg";
import inauguration2 from "../../assets/hero2.jpg";
import inauguration3 from "../../assets/hero3.jpg";
import inauguration4 from "../../assets/hero4.jpg";
import inauguration5 from "../../assets/hero5.jpg";
import inauguration6 from "../../assets/hero6.jpg";
import inauguration7 from "../../assets/hero7.jpg";
import inauguration8 from "../../assets/hero8.jpg";
import inauguration9 from "../../assets/hero9.jpg";
import inauguration10 from "../../assets/hero10.jpg";

import { Modal, Carousel } from "react-bootstrap";
import "./Newsandevents.css";

export default function Newsandevents() {
    const [show, setShow] = useState(false);
    const [activeGallery, setActiveGallery] = useState(null);

    const inaugurationGallery = {
        title: "Inauguration Ceremony:Building the Future, Together",
        photos: "10 Photos",
        desc: "The inauguration of our new office stands as a proud moment for the entire risposta® team - a reflection of shared effort, vision, and commitment. Captured in this moment are the faces behind our success, associates whose dedication continues to drive our growth and inspire innovation.\nThis celebration is more than a milestone; it symbolizes the strength of collaboration and the power of people working with purpose. As we move forward, the synergy and spirit seen here will continue to shape our journey toward delivering exceptional value to our customers across the world.",
        images: [
            inauguration1, inauguration2, inauguration3, inauguration4, inauguration5,
            inauguration6, inauguration7, inauguration8, inauguration9, inauguration10
        ]
    };

    const handleShow = (gallery) => {
        setActiveGallery(gallery);
        setShow(true);
    };

    return (
        <div className="news-events-page">
            <div className="container my-5">
                <div className="row">
                    <div className="row" style={{textAlign:'center'}}>
                        <h1 style={{ textAlign: 'center' }}>EVENTS</h1>
                        <div
                            className="col-md-3 col-sm-6 mb-4"
                            onClick={() => handleShow(inaugurationGallery)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="gallery-card p-2 shadow-sm rounded">
                                <div className="gallery-preview-grid-vertical">
                                    <div className="small-imgs">
                                        <img src={inauguration3} alt="Inauguration preview 1" className="img-fluid mb-2" />
                                        <img src={inauguration2} alt="Inauguration preview 2" className="img-fluid" />
                                    </div>
                                    <div className="large-img">
                                        <img src={inauguration1} alt="Inauguration main preview" className="img-fluid h-100" />
                                    </div>
                                </div>
                                <h6 className="fw-bold mt-2">Inauguration Ceremony</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal show={show} onHide={() => setShow(false)} centered size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{activeGallery?.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="row equal-height-row">
                            <div className="col-md-5 text-section">
                                <div className="description-text h-100 d-flex align-items-center">
                                    {activeGallery?.desc.includes("\n") ? (
                                        <ul className="modal-desc mb-0">
                                            {activeGallery.desc.split("\n").map((line, idx) => (
                                                <li key={idx}>{line.trim()}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="mb-0">{activeGallery?.desc}</p>
                                    )}
                                </div>
                            </div>

                            <div className="col-md-7 image-section">
                                <div className="carousel-section h-100">
                                    <Carousel interval={2000} fade controls={false} indicators={false} pause={false}>
                                        {activeGallery?.images.map((photo, idx) => (
                                            <Carousel.Item key={idx}>
                                                <div className="carousel-image-container h-100">
                                                    <img 
                                                        className="d-block w-100 h-100 object-fit-cover" 
                                                        src={photo} 
                                                        alt={`Inauguration ceremony photo ${idx + 1}`} 
                                                    />
                                                </div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}
